import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderComponent } from '@shared/components';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { DashboardHeaderLink } from '../../_core/interfaces';

@Component({
    selector: 'app-dashboard-table-section',
    standalone: true,
    imports: [DividerModule, ButtonModule, RouterModule, BadgeModule, TranslateModule, LoaderComponent],
    templateUrl: './dashboard-table-section.component.html',
    styleUrls: ['./dashboard-table-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardTableSectionComponent {
    readonly id = input.required<string>();
    readonly headerIcon = input.required<string>();
    readonly headerTitle = input.required<string>();
    readonly headerTitleLink = input.required<DashboardHeaderLink>();
    readonly headerBadgeNumber = input.required<number>();
    readonly headerButtonLabel = input.required<string>();
    readonly headerButtonLink = input.required<string>();

    readonly isLoadingData = input(false);
    readonly totalNumberOfItems = input(0);
    readonly description = input('');

    readonly onHeaderTitleClick = output();
    readonly onActionButtonClick = output();
}
